/**
 * The User Management route's constants — ADR 9014. Their own module so the router, the rails,
 * the palette and the screen's two halves import them without importing each other.
 */

import type { RouteRequires } from '../../../features/manifest';

export const ADMIN_USERS_PATH = '/admin/users';

/** The route's `requires`, in the manifest's own type, read by `RequiresGate`. */
export const ADMIN_USERS_REQUIRES: RouteRequires = ['administrator'];

/**
 * The `realm-management` roles this screen's calls need. `query-groups` is in `bata-reqs` ADR
 * 1001's grant because Keycloak's `view-users` composes it, but no call here reads a group.
 */
export const USER_ADMIN_GRANTS: readonly string[] = ['view-users', 'query-users', 'manage-users'];

/** The search is the URL's (G2.2), so a filtered list is a link. */
export const SEARCH_PARAM = 'q';

/** Every query key this screen uses starts here, so one invalidation refreshes them all. */
export const ADMIN_QUERY_ROOT = 'keycloak-admin';

/**
 * «Attività utenti» (ADR 9059) — a foundations route, offered from here: the account menu, the
 * palette and this screen's header, to the same administrators. Its own `requires` and capability
 * are on its manifest route; this is the link, opened with no period — the page asks for one.
 */
export const USER_ACTIVITY_PATH = '/foundations/user-activity';
